import { useNavigate, useSearchParams } from "react-router-dom";

import { MODAL_ROUTES } from "../components/modals/router/ModalRoutes";

const useModalRouter = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const openModal = (
    name: MODAL_ROUTES | MODAL_ROUTES[],
    params?: { [key: string]: string | undefined | null },
    reset: boolean = false,
  ) => {
    const newParams = new URLSearchParams(reset ? "" : searchParams);
    const modalPath = Array.isArray(name) ? name.join("/") : name;

    newParams.set("modal", modalPath);

    if (params) {
      for (const item in params) {
        const param = params[item];
        if (param) newParams.set(item, param.toString());
      }
    }

    // setSearchParams(newParams, { preventScrollReset: true });
    navigate(`?${newParams}`, { preventScrollReset: true });
  };

  const closeModal = () => {
    const returnTo = searchParams.get("return_to");

    if (returnTo) {
      setSearchParams(returnTo, { preventScrollReset: true });

      return;
    }
    setSearchParams("", { preventScrollReset: true });
  };

  const goBack = () => {
    navigate(-1);
  };

  const currentModal = searchParams.get("modal") as MODAL_ROUTES | null;

  return {
    openModal,
    closeModal,
    currentModal,
    goBack,
    isOpen: Boolean(currentModal),
  };
};

export default useModalRouter;
